module.exports = __webpack_public_path__ + "img/banner.32e80558.png";